import { render, staticRenderFns } from "./edit_password.vue?vue&type=template&id=3d6a63c3&scoped=true&"
import script from "./edit_password.vue?vue&type=script&lang=js&"
export * from "./edit_password.vue?vue&type=script&lang=js&"
import style0 from "./edit_password.vue?vue&type=style&index=0&id=3d6a63c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a63c3",
  null
  
)

export default component.exports